import { svg01, svg02, svg03, svg04 } from './icons';

export default {
	items: [
		{
			icon: svg01,
			title: 'Find Freelancers',
			link: 'https://www.69work.com/marketplace/skills',
			internal: false,
		},
		{
			icon: svg02,
			title: 'Become a Seller',
			link: '/sell',
			internal: true,
		},
		{
			icon: svg03,
			title: 'Best Web Hosting',
			link: 'https://cloud.69work.com',
			internal: false,
		},
		{
			icon: svg04,
			title: 'Wishlist',
			link: '/wishlist',
			internal: true,
		},
	],
};
